(function () {
  'use strict';

  function parseRGB(value) {
    var start = (value || '').indexOf('(');
    if (start < 0) return null;
    var parts = value.slice(start + 1, value.indexOf(')')).split(',');
    return {
      r: parseFloat(parts[0]),
      g: parseFloat(parts[1]),
      b: parseFloat(parts[2]),
      a: parts.length > 3 ? parseFloat(parts[3]) : 1
    };
  }

  function linearize(value) {
    value = value / 255;
    return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
  }

  function luminance(rgb) {
    return 0.2126 * linearize(rgb.r) + 0.7152 * linearize(rgb.g) + 0.0722 * linearize(rgb.b);
  }

  function contrast(first, second) {
    var high = Math.max(first, second);
    var low = Math.min(first, second);
    return (high + 0.05) / (low + 0.05);
  }

  function hasClass(element, className) {
    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') >= 0;
  }

  function isSelected(element) {
    return hasClass(element, 'selected') ||
      hasClass(element, 'active') ||
      hasClass(element, 'is-active') ||
      hasClass(element, 'current') ||
      hasClass(element, 'is-selected') ||
      element.getAttribute('aria-current') === 'true';
  }

  function fixSwatches(root) {
    (root || document).querySelectorAll('.color-button').forEach(function (button) {
      try {
        var background = parseRGB(getComputedStyle(button).backgroundColor);
        var useWhite = true;
        if (background && background.a > 0.5) {
          var backgroundLuminance = luminance(background);
          useWhite = contrast(backgroundLuminance, 1) >= contrast(backgroundLuminance, 0);
        }

        var code = button.querySelector('.a11y-code');
        if (!code) {
          var text = (button.textContent || '').trim();
          if (text) {
            code = document.createElement('span');
            code.className = 'a11y-code';
            code.textContent = text;
            Array.prototype.slice.call(button.childNodes).forEach(function (node) {
              if (node.nodeType === 3) button.removeChild(node);
            });
            button.appendChild(code);
          }
        }

        if (code) {
          code.style.color = useWhite ? '#ffffff' : '#000000';
          code.style.backgroundColor = useWhite ? 'rgba(0,0,0,0.72)' : 'rgba(255,255,255,0.9)';
          code.style.padding = '0 3px';
          code.style.borderRadius = '3px';
          code.style.fontWeight = '600';
          code.style.display = 'inline-block';
        }
      } catch (error) {}

      button.setAttribute('aria-pressed', isSelected(button) ? 'true' : 'false');
    });

    var groups = [];
    (root || document).querySelectorAll('.color-button').forEach(function (button) {
      var group = button.closest('[role=group], fieldset, .product__block--variant-picker, .variant-picker');
      if (
        group &&
        groups.indexOf(group) < 0 &&
        !group.getAttribute('aria-label') &&
        !group.getAttribute('aria-labelledby') &&
        !group.querySelector('legend')
      ) {
        groups.push(group);
        group.setAttribute('aria-label', 'Choose your shade');
      }
    });
  }

  function observeSwatches() {
    var buttons = document.querySelectorAll('.color-button');
    if (!buttons.length) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var button = mutation.target;
        if (button && button.setAttribute) {
          button.setAttribute('aria-pressed', isSelected(button) ? 'true' : 'false');
        }
      });
    });
    buttons.forEach(function (button) {
      observer.observe(button, { attributes: true, attributeFilter: ['class', 'aria-current'] });
    });
  }

  function fixLogoCloud() {
    document.querySelectorAll('[class*=track-horizontal]').forEach(function (track, index) {
      track.querySelectorAll('a[class*=slide-]').forEach(function (link) {
        var href = link.getAttribute('href');
        if (!href || href.trim() === '' || href.trim() === '#') link.removeAttribute('href');
        var image = link.querySelector('img');
        if (image && (!image.getAttribute('alt') || image.getAttribute('alt').trim() === '')) {
          image.setAttribute('alt', 'Featured press logo');
        }
        if (href && href.trim() && !link.getAttribute('aria-label')) {
          link.setAttribute('aria-label', (image && image.getAttribute('alt')) || 'Featured press logo');
        }
      });
      if (index > 0) track.setAttribute('aria-hidden', 'true');
    });
  }

  function fixCircleMenu() {
    document.querySelectorAll('a[class*=circle-icon-]').forEach(function (link) {
      if (link.getAttribute('aria-label') || (link.textContent || '').trim()) return;
      var item = link.closest('[class*=circle-item-]') || link.parentElement;
      var label = item && item.querySelector('[class*=circle-text-]');
      var image = link.querySelector('img');
      var name = (label && label.textContent.trim()) || (image && image.getAttribute('alt')) || '';
      if (name) link.setAttribute('aria-label', name);
    });
  }

  function fixAriaControls(root) {
    (root || document).querySelectorAll('[aria-controls]').forEach(function (control) {
      var id = control.getAttribute('aria-controls');
      if (!id) {
        control.removeAttribute('aria-controls');
        return;
      }
      if (document.getElementById(id)) return;
      var scope = control.closest('.accordion, .accordion__inner, .collapsible, details, .product__block') ||
        control.parentElement;
      var panel = scope && scope.querySelector('.accordion__content, .accordion__panel, .collapsible__content');
      if (panel) {
        if (!panel.id) panel.id = id;
        else control.setAttribute('aria-controls', panel.id);
      } else {
        control.removeAttribute('aria-controls');
      }
    });
  }

  function replaceReference(value, oldId, newId) {
    return (value || '').split(/\s+/).map(function (token) {
      return token === oldId ? newId : token;
    }).join(' ');
  }

  function fixDuplicateIds() {
    var seen = {};
    document.querySelectorAll('[id]').forEach(function (element) {
      var oldId = element.id;
      if (!oldId) return;
      if (!seen[oldId]) {
        seen[oldId] = 1;
        return;
      }

      seen[oldId] += 1;
      var newId = oldId + '--a11y-' + seen[oldId];
      while (document.getElementById(newId)) {
        seen[oldId] += 1;
        newId = oldId + '--a11y-' + seen[oldId];
      }

      var scope = element.closest('.accordion, .swiper-slide, label, form, .drawer-menu, section') ||
        element.parentElement ||
        document;

      scope.querySelectorAll('[aria-controls], [aria-labelledby], [aria-describedby], [for], [href^="#"]').forEach(function (reference) {
        ['aria-controls', 'aria-labelledby', 'aria-describedby'].forEach(function (attribute) {
          if (reference.hasAttribute(attribute)) {
            reference.setAttribute(attribute, replaceReference(reference.getAttribute(attribute), oldId, newId));
          }
        });
        if (reference.getAttribute('for') === oldId) reference.setAttribute('for', newId);
        if (reference.getAttribute('href') === '#' + oldId) reference.setAttribute('href', '#' + newId);
      });

      element.setAttribute('data-a11y-original-id', oldId);
      element.id = newId;
    });
  }

  function fixTestimonialControls() {
    document.querySelectorAll('[class*=testimonials-video-btn-]').forEach(function (control, index) {
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
      if (!control.getAttribute('aria-label')) {
        control.setAttribute('aria-label', 'Play customer testimonial video ' + (index + 1));
      }
      var icon = control.querySelector('svg');
      if (icon) {
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');
      }
      if (control.getAttribute('data-a11y-keyboard-ready') === 'true') return;
      control.setAttribute('data-a11y-keyboard-ready', 'true');
      control.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          control.click();
        }
      });
    });
  }

  function fixDecorativeVideos() {
    document.querySelectorAll('video[muted][autoplay][loop]:not([controls])').forEach(function (video, index) {
      video.setAttribute('aria-hidden', 'true');
      video.setAttribute('tabindex', '-1');
      var wrapper = video.closest('[class*=video-slide-video-]');
      if (wrapper && !wrapper.getAttribute('role')) {
        wrapper.setAttribute('role', 'img');
        wrapper.setAttribute('aria-label', 'Product demonstration video ' + (index + 1));
      }
    });
  }

  function fixVideoClose(root) {
    (root || document).querySelectorAll('[class*=video-modal-close], [class*=modal-close]').forEach(function (button) {
      var named = button.getAttribute('aria-label') ||
        (button.textContent || '').trim() ||
        button.querySelector('img[alt]:not([alt=x])');
      if (!named) button.setAttribute('aria-label', 'Close');
    });
  }

  function fixFrames() {
    var purchaseBar = document.getElementById('PBarNextFrame');
    if (purchaseBar && !purchaseBar.getAttribute('title')) {
      purchaseBar.setAttribute('title', 'Sticky purchase bar');
    }
    document.querySelectorAll('iframe:not([title])').forEach(function (frame) {
      if (frame.getAttribute('aria-hidden') === 'true') return;
      var id = frame.id || '';
      if (id.indexOf('web-pixel') >= 0 || id.indexOf('hjSafeContext') >= 0) {
        frame.setAttribute('aria-hidden', 'true');
        frame.setAttribute('tabindex', '-1');
        return;
      }
      if (frame.offsetHeight > 0) frame.setAttribute('title', 'Embedded content');
    });
  }

  function fixCartNote() {
    var note = document.querySelector('.cart__footer-order-note-wrapper');
    if (!note) return;
    function sync() {
      var hidden = note.getAttribute('aria-hidden') === 'true';
      note.querySelectorAll('a[href], button, input, textarea, select, [tabindex]').forEach(function (control) {
        if (hidden) control.setAttribute('tabindex', '-1');
        else if (control.getAttribute('tabindex') === '-1') control.removeAttribute('tabindex');
      });
    }
    sync();
    if (note.getAttribute('data-a11y-note-ready') === 'true') return;
    note.setAttribute('data-a11y-note-ready', 'true');
    new MutationObserver(sync).observe(note, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function fixImageAlt(root) {
    (root || document).querySelectorAll('img:not([alt])').forEach(function (image) {
      var link = image.closest('a');
      var name = link && (link.getAttribute('aria-label') || link.getAttribute('title') || (link.textContent || '').trim());
      image.setAttribute('alt', name ? name.slice(0, 100) : '');
    });
  }

  function fixMissingH1() {
    var main = document.querySelector('main');
    if (!main || main.querySelector('h1')) return;
    var heading = document.createElement('h1');
    heading.className = 'visually-hidden';
    heading.textContent = (document.title || '').split('–')[0].trim() || 'Best Bronze';
    main.insertBefore(heading, main.firstChild);
  }

  function fixKlaviyo() {
    document.querySelectorAll('.klaviyo-close-form, [class*=klaviyo-close]').forEach(function (button) {
      if (button.getAttribute('tabindex') === '-1') button.setAttribute('tabindex', '0');
      if (!button.getAttribute('aria-label') || !button.getAttribute('aria-label').trim()) {
        button.setAttribute('aria-label', 'Close');
      }
    });
  }

  function runAll(root) {
    [
      fixSwatches,
      fixLogoCloud,
      fixCircleMenu,
      fixAriaControls,
      fixTestimonialControls,
      fixDecorativeVideos,
      fixVideoClose,
      fixFrames,
      fixCartNote,
      fixImageAlt,
      fixMissingH1,
      fixKlaviyo,
      fixDuplicateIds
    ].forEach(function (fix) {
      try {
        fix(root);
      } catch (error) {}
    });
  }

  function init() {
    runAll(document);
    try {
      observeSwatches();
    } catch (error) {}

    try {
      window.addEventListener('klaviyoForms', function (event) {
        if (
          event &&
          event.detail &&
          (event.detail.type === 'open' ||
            event.detail.type === 'embedOpen' ||
            event.detail.type === 'stepSubmit')
        ) {
          setTimeout(fixKlaviyo, 60);
          setTimeout(fixKlaviyo, 400);
        }
      });
    } catch (error) {}

    var runs = 0;
    var timer = setInterval(function () {
      runAll(document);
      runs += 1;
      if (runs >= 4) clearInterval(timer);
    }, 1500);

    try {
      var pending = false;
      var observer = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () {
          pending = false;
          runAll(document);
        }, 700);
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () {
        try {
          observer.disconnect();
        } catch (error) {}
      }, 20000);
    } catch (error) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
